<template>
  <div class="col-xs-12 py-3 mb-3 px-5">
    <div class="text-center fw-bold py-4">
      Wrapping is not avaliable
    </div>
  </div>
</template>

<script>
export default {
  name: "WrapPeercoin",
};
</script>
